import React from 'react';

const ToggleSwitch = ({ isActive, onChange }) => {
    return (
        <div className="flex items-center space-x-2">
            <div
                className={`w-14 h-8 flex items-center ${isActive ? 'bg-green-500 dark:bg-green-700' : 'bg-gris dark:bg-gris/30' } rounded-full p-1 cursor-pointer transition duration-300`}
                onClick={() => onChange(!isActive)}
            >
                <div
                    className={`bg-blanc size-6 rounded-full shadow-md transform transition duration-300 ${
                        isActive ? 'translate-x-6' : 'translate-x-0'
                    }`}
                />
            </div>
        </div>
    );
};

export default ToggleSwitch;